import MainLayout from "../Layouts/MainLayout";
import PublicAppShell from "../Layouts/PublicAppShell";
import { lazy, Suspense } from "react";
import { createBrowserRouter } from "react-router-dom";
import Productos from '../Pages/Productos/Productos'
import Usuarios from '../Pages/Usuarios/Usuarios'
import Banners from "./Banners/Banners";
import Main from "./Main/Main";
import Categorias from "./Categorias/Categorias";
import Codigos from "./Codigos/Codigos";
import PageDetail from '../Pages/PageDetail/PageDetail';
import PageProductos from "./PageProductos/PageProductos";
import PageCategorias from "./PageCategorias/PageCategorias";
import Pedidos from "./Pedidos/Pedidos";
import Tienda from "./Tienda/Tienda";
import MetodosDePago from "./MetodosDePago/MetodosDePago";
import MiPedido from "../Components/MiPedido/MiPedido";
import Demo from "./Demo/Demo";

const WhatsAppInboxPage = lazy(() => import("../features/whatsappInbox/WhatsAppInboxPage"));

export const router = createBrowserRouter([

    {
        path: "/",
        element: <PublicAppShell />,
        children: [
            {
                index: true,
                element: <Demo />,
            },
            {
                path: `producto/:idProducto/:producto`,
                element: <PageDetail />,
            },
            {
                path: `productos`,
                element: <PageProductos />,
            },
            {
                path: `categorias`,
                element: <PageCategorias />,
            },
            {
                path: `mi-pedido`,
                element: <MiPedido />,
            },
        ]
    },
    {
        path: "/",
        element: <MainLayout />,
        children: [
            {
                path: `/dashboard`,
                element: <Main />,
            },
            {
                path: `/dashboard/productos`,
                element: <Productos />,
            },
            {
                path: `/dashboard/usuarios`,
                element: <Usuarios />,
            },
            {
                path: `/dashboard/banners`,
                element: <Banners />,
            },

            {
                path: `/dashboard/categorias`,
                element: <Categorias />,
            },

            {
                path: `/dashboard/promociones`,
                element: <Codigos />,
            },
            {
                path: `/dashboard/pedidos/view?`,
                element: <Pedidos />,
            },
            {
                path: `/dashboard/mi-tienda`,
                element: <Tienda />,
            },
            {
                path: `/dashboard/metodos-de-pago`,
                element: <MetodosDePago />,
            },
            {
                path: `/dashboard/whatsapp`,
                element: (
                    <Suspense fallback={<div role="status">Cargando Atención WhatsApp…</div>}>
                        <WhatsAppInboxPage />
                    </Suspense>
                ),
            },
        ],
    },
  ],
  // --- Configuración Adicional del Router ---
  {
    //basename: "/Shop", // ✨ ¡AQUÍ ESTÁ LA CONFIGURACIÓN! ✨
  }
);
